import { render, staticRenderFns } from "./SmsListUser.vue?vue&type=template&id=89b63826&scoped=true&"
import script from "./SmsListUser.vue?vue&type=script&lang=js&"
export * from "./SmsListUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "89b63826",
  null
  
)

export default component.exports